import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { InsuranceProviders } from '../../enums/insurance-providers';
import * as Actions from '../../store/csw/csw.actions';

export const useInsuranceProviderState = (
  fulfillmentPlanId,
  insuranceProvider,
  clearInsuranceValues,
  initInsuranceValue,
  onConfigurationChange,
) => {
  const dispatch = useDispatch();

  const updateInsuranceProvider = useCallback(
    (newInsuranceProviderName, sendAnalytics) => {
      const insuranceProviderEnum = InsuranceProviders[newInsuranceProviderName];
      onConfigurationChange({ insuranceProvider: insuranceProviderEnum.name }, {}, sendAnalytics);
      dispatch(
        Actions.updateShipmentConfiguration(fulfillmentPlanId, {
          insuranceProvider: insuranceProviderEnum.name,
        }),
      );
    },
    [dispatch, fulfillmentPlanId, onConfigurationChange],
  );

  const onInsuranceProviderChange = useCallback(
    (newInsuranceProviderName, sendAnalytics) => {
      if (newInsuranceProviderName === InsuranceProviders.None.name) {
        clearInsuranceValues();
        updateInsuranceProvider(newInsuranceProviderName, sendAnalytics);
        dispatch(
          Actions.changeInsuranceValueOnAllPackages(fulfillmentPlanId, {
            insuredValue: undefined,
          }),
        );
        return;
      }
      updateInsuranceProvider(newInsuranceProviderName, sendAnalytics);

      if (insuranceProvider.name === InsuranceProviders.None.name) {
        initInsuranceValue(newInsuranceProviderName);
      }
    },
    [fulfillmentPlanId, dispatch, clearInsuranceValues, updateInsuranceProvider, initInsuranceValue, insuranceProvider],
  );

  const onPresetWithInsuranceProviderApplied = useCallback(
    (newInsuranceProviderName) => {
      updateInsuranceProvider(newInsuranceProviderName);
    },
    [updateInsuranceProvider],
  );

  return useMemo(
    () => ({
      onInsuranceProviderChange,
      onPresetWithInsuranceProviderApplied,
    }),
    [onInsuranceProviderChange, onPresetWithInsuranceProviderApplied],
  );
};
